import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, MessageCircle, ClipboardCheck } from 'lucide-react';

const trackClick = (name, params = {}) => {
    if (typeof window !== 'undefined' && window.trackConversion) window.trackConversion(name, params);
};

/**
 * MobileStickyBar — 3-column always-visible action bar for mobile users.
 * Call · WhatsApp · Get a Quote. Highest-impact CTA on mobile.
 * Hidden on admin routes; hidden on Contact page (form already visible).
 */
const MobileStickyBar = () => {
    const location = useLocation();

    if (location.pathname.startsWith('/admin')) return null;
    if (location.pathname === '/contact') return null;

    return (
        <div
            className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-neutral-200 shadow-[0_-4px_16px_rgba(0,0,0,0.06)] safe-bottom"
            data-testid="mobile-sticky-bar"
        >
            <div className="grid grid-cols-3">
                <a
                    href="tel:+19842010767"
                    onClick={() => trackClick('phone_click', { location: 'mobile_sticky' })}
                    className="flex flex-col items-center justify-center gap-0.5 py-3 label-caps text-[11px] text-neutral-900 hover:bg-neutral-50 active:bg-neutral-100 transition-colors border-r border-neutral-200 min-h-[56px]"
                    data-testid="mobile-sticky-call"
                    aria-label="Call Dry Ice Bulls"
                >
                    <Phone className="h-4 w-4 text-brand-primary" />
                    Call Now
                </a>
                <a
                    href="https://wa.me/19842010767"
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => trackClick('whatsapp_click', { location: 'mobile_sticky' })}
                    className="flex flex-col items-center justify-center gap-0.5 py-3 label-caps text-[11px] text-neutral-900 hover:bg-neutral-50 active:bg-neutral-100 transition-colors border-r border-neutral-200 min-h-[56px]"
                    data-testid="mobile-sticky-whatsapp"
                    aria-label="WhatsApp Dry Ice Bulls"
                >
                    <MessageCircle className="h-4 w-4 text-brand-primary" />
                    WhatsApp
                </a>
                <Link
                    to="/contact?interest=quote&subject=Equipment%20Quote"
                    onClick={() => trackClick('quote_click', { location: 'mobile_sticky' })}
                    className="flex flex-col items-center justify-center gap-0.5 py-3 label-caps text-[11px] bg-brand-primary text-white hover:bg-brand-primaryHover active:opacity-90 transition-colors min-h-[56px]"
                    data-testid="mobile-sticky-quote"
                    aria-label="Get a quote"
                >
                    <ClipboardCheck className="h-4 w-4" />
                    Get a Quote
                </Link>
            </div>
        </div>
    );
};

export default MobileStickyBar;
